import _ from 'lodash';
import { createSelector } from 'reselect';
import { getMusicState } from './music';
import { getConfigLoading, getConfigError } from './config';
import { getSessionLoading, getSessionError } from './session';

export const getPlaylistsState = createSelector(
  [getMusicState],
  music => _.get(music, 'playlists'),
);

export const getPlaylistsModel = createSelector(
  [getPlaylistsState],
  playlistsState => _.get(playlistsState, 'model', false),
);

export const getPlaylistsLoading = createSelector(
  [getPlaylistsState],
  playlistsState => _.get(playlistsState, 'loading'),
);

export const getPlaylistsError = createSelector(
  [getPlaylistsState],
  playlistsState => _.get(playlistsState, 'error'),
);

export const getPlaylistsItems = createSelector(
  [getPlaylistsModel],
  playlistsModel =>
    _.flow(
      obj => _.get(obj, 'GRID.items'),
      col => _.map(col, ({ entity_id: id, img: image }) => ({ id, image })),
    )(playlistsModel),
);

export const getMuiscLoading = createSelector(
  [getConfigLoading, getSessionLoading, getPlaylistsLoading],
  (configLoading, sessionLoading, playlistsLoading) =>
    _.some([configLoading, sessionLoading, playlistsLoading]),
);

export const getMuiscError = createSelector(
  
  [getConfigError, getSessionError, getPlaylistsError],
  (configError, sessionError, playlistsError) =>
    _.some([configError, sessionError, playlistsError]),
);
